import geometry from '@/assets/js/geometry'

const testPoly = (point, vs) => {
  let x = point.lat
  let y = point.lng

  let inside = false
  for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    let xi = vs[i].lat
    let yi = vs[i].lng
    let xj = vs[j].lat
    let yj = vs[j].lng

    let intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
    if (intersect) inside = !inside
  }

  return inside
}

const isInWarsaw = coords => (
  !!geometry.find(district => testPoly(coords, district.coords))
)

export default isInWarsaw



// WEBPACK FOOTER //
// ./src/assets/js/map/isInWarsaw.js